const DEFAULT_LOCALE = "en-US"

export const toDate = (value, locale = DEFAULT_LOCALE) => new Intl.DateTimeFormat(locale, {
  weekday: "short",
  month: "long",
  day: "numeric"
}).format(new Date(value))

export const toTime = (value, locale = DEFAULT_LOCALE) => new Intl.DateTimeFormat(locale, {
  hour: "numeric",
  minute: "numeric"
}).format(new Date(value))
